<template>
  <div>
    <dialog-conversation-history :sender_name="sender_name"/>
    <dialog-block-customer/>
    <dialog-change-request-support/>
    <dialog-create-m-a-d-template/>
    <dialog-update-m-a-d-template/>
    <dialog-m-a-d-template/>
    <dialog-create-quick-response/>
    <dialog-import-agent-quick-response/>
  </div>
</template>

<script>
import DialogConversationHistory from "components/dialog/DialogConversationHistory";
import DialogBlockCustomer from "components/dialog/DialogBlockCustomer";
import DialogChangeRequestSupport from "components/dialog/DialogChangeRequestSupport";
import DialogCreateMADTemplate from "components/dialog/DialogCreateMADTemplate";
import DialogMADTemplate from "components/dialog/DialogMADTemplate";
import DialogUpdateMADTemplate from "components/dialog/DialogUpdateMADTemplate";
import DialogCreateQuickResponse from "components/dialog/DialogCreateQuickResponse";
import DialogImportAgentQuickResponse from "components/dialog/DialogImportAgentQuickResponse";
export default {
  name: "Index",
  props:{
    sender_name: String
  },
  components: {
    DialogUpdateMADTemplate,
    DialogMADTemplate, DialogCreateMADTemplate, DialogBlockCustomer, DialogChangeRequestSupport,
    DialogConversationHistory, DialogCreateQuickResponse, DialogImportAgentQuickResponse},
  comments: {
    DialogConversationHistory: () => import(
        "./DialogConversationHistory"
        ),
    DialogBlockCustomer: () => import(
        "./DialogBlockCustomer"
        ),
    DialogChangeRequestSupport: () => import(
        "./DialogChangeRequestSupport"
        ),
    DialogCreateMADTemplate: () => import(
        "./DialogCreateMADTemplate"
        ),
    DialogMADTemplate: () => import(
        "./DialogMADTemplate"
        ),
    DialogUpdateMADTemplate: () => import(
        "./DialogUpdateMADTemplate"
        ),
    DialogCreateQuickResponse: () => import(
        "./DialogCreateQuickResponse"
        ),
    DialogImportAgentQuickResponse: () => import(
        "./DialogImportAgentQuickResponse"
        )

  }
}
</script>

<style scoped>

</style>
